import React, { useState } from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Box, IconButton, Tooltip as MuiTooltip, Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { useData } from '../context/DataContext';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend, ChartDataLabels);

const RotacionPersonal = ({ selectedIndustries = [], onBarClick = () => {} }) => {
  const [infoOpen, setInfoOpen] = useState(false);
  const { getPersonnelRotation, dataReady } = useData();

  // Get data from Excel (3 years)
  const excelData = dataReady ? getPersonnelRotation() : { labels: [], data2022: [], data2023: [], data2024: [] };

  // Use Excel data or fallback
  const allLabels = excelData.labels.length > 0
    ? excelData.labels
    : ['Alimentos', 'Automotriz', 'Construcción', 'Manufactura', 'Retail', 'Sector salud/ Farmacéuticas', 'Servicios Logísticos'];

  const allData2022 = excelData.data2022.length > 0 ? excelData.data2022 : [13, 14, 11, 8, 23, 10, 27];
  const allData2023 = excelData.data2023.length > 0 ? excelData.data2023 : [27, 25, 12, 48, 28, 30, 20];
  const allData2024 = excelData.data2024.length > 0 ? excelData.data2024 : [29, 40, 26, 34, 30, 17, 22];

  const labels = selectedIndustries.length > 0 ? selectedIndustries : allLabels;

  const getValuesForLabels = (allValues) => labels.map((label) => {
    const index = allLabels.indexOf(label);
    return index !== -1 ? allValues[index] : 0;
  });

  const chartData = {
    labels: labels,
    datasets: [
      {
        label: '2023',
        data: getValuesForLabels(allData2022),
        backgroundColor: '#A2AEBB',
      },
      {
        label: '2024',
        data: getValuesForLabels(allData2023),
        backgroundColor: '#476A8E',
      },
      {
        label: '2025',
        data: getValuesForLabels(allData2024),
        backgroundColor: '#1F3D58',
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: 'y',
    plugins: {
      legend: {
        display: true,
        position: 'top',
      },
      tooltip: {
        callbacks: {
          label: (context) => `${context.dataset.label}: ${context.raw}%`,
        },
      },
      datalabels: {
        color: '#000',
        font: { weight: 'bold', size: 10 },
        anchor: 'end',
        align: 'right',
        offset: 8,
        formatter: (value) => `${value}%`,
        clip: false,
      },
    },
    scales: {
      x: {
        beginAtZero: true,
        max: 60,
        ticks: {
          stepSize: 10,
        },
        title: {
          display: true,
          text: 'Porcentaje (%)',
        },
      },
      y: {
        ticks: {
          font: { size: 12 },
        },
        title: {
          display: true,
          text: 'Industria',
        },
      },
    },
  };

  const infoContent = {
    formula: 'Rotación Mensual (%) = (Número de desvinculaciones de áreas logísticas y de almacén por mes / Promedio de Empleados del mes) x 100. Rotación anual: (Suma de rotaciones mensuales) / 12',
    description: 'Muestra la tasa de movilidad del personal involucrado en áreas de logística.',
  };

  return (
    <div style={{ maxWidth: '800px', height: '500px', margin: '0 auto', padding: '20px' }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <MuiTooltip title="Información de la gráfica">
          <IconButton onClick={() => setInfoOpen(true)}>
            <InfoIcon />
          </IconButton>
        </MuiTooltip>
      </Box>
      <Bar data={chartData} options={options} />
      <Dialog open={infoOpen} onClose={() => setInfoOpen(false)}>
        <DialogTitle>Información de la Gráfica</DialogTitle>
        <DialogContent>
          <p><strong>Fórmula:</strong> {infoContent.formula}</p>
          <p><strong>Descripción:</strong> {infoContent.description}</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setInfoOpen(false)} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default RotacionPersonal;
